<template>
  <div class="payment">
    <breadcrumb :link-list="breadcrumbList"></breadcrumb>
    <div v-if="payResult == ''" class="pay main">
      <div class="card">
        <div class="card-left">
          <div class="title">
            <img src="../../../assets/image/AllGame/payment/alipay.png" alt="">
            需支付金额
          </div>
          <div class="price">
            ¥{{orderInfo.order_amount}}
          </div>
          <div id="qrcode">
            <div class="qrcode" ref="qrCodeUrl"></div>
          </div>
          <div class="tip">
            打开手机
            <span>支付宝</span>
            扫一扫
            <i class="iconfont pxb7-scan-code"></i>
          </div>
        </div>
        <div class="card-right">
          <div class="time">
            剩余支付时间
            <span>
                <count-down class="count_down" :end-time="orderInfo.expire_time" :start-time="orderInfo.add_time" :key="orderInfo.add_time" @countDownChange="countDownChange($event)"></count-down>
<!--                <count-down class="count_down" :endTime="1675414990" :startTime="1675414390" @countDownChange="countDownChange($event)"></count-down>-->
            </span>
          </div>
          <div class="scanCode">
            <img src="../../../assets/image/AllGame/payment/scanCode.png" alt="">
            <div class="scanCode-tip">
              <div>
                <span>打开手机支付宝</span>
                手机上安装并登陆支付宝
              </div>
              <div></div>
              <div>
                <span>扫描二维码付款</span>
                从“首页”打开“扫一扫” <br/>
                瞄准二维码扫码并支付
              </div>
            </div>
          </div>
          <div class="illustrate">
            <div>
              为确保资金安全,支付二维码会
              <span>自动刷新</span>
            </div>
            <div>
              支持余额、银行卡 (储蓄卡和信用卡) 、花呗、花呗分期
            </div>
          </div>
        </div>
      </div>

      <div class="Graphicdetailsfooter" v-html="alipayFrom"></div>
    </div>
    <div v-else-if="payResult == 'success'" class="payment-success main">
      <div class="card">
        <div class="title">
          <img src="../../../assets/image/AllGame/payment/payment_success.png" alt="">
          支付成功
        </div>
        <div class="illustrate">
          支付成功后可从站内信进入群聊交易<br/>等待卖家进行交易
          <div>
            如超过6小时卖家未交易，则可申请退款
          </div>
        </div>
        <router-link to="/personalCenter/siteNotice" class="btn">
          进入站内信
        </router-link>
      </div>
    </div>
    <div v-else class="payment-error main">
      <div class="card">
        <div class="title">
          <img src="../../../assets/image/AllGame/payment/payment_error.png" alt="">
          支付失败
        </div>
        <div class="illustrate">
          <i class="iconfont pxb7-warning-icon"></i>该订单已取消，支付超时或商品已被购买
        </div>
        <router-link tag="div" class="btn" to="/">
          再逛逛
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2';
import breadcrumb from "@/components/breadcrumb";
import countDown from "@/components/countDown";
import {apiPayQuery, apiPaydetail, apiOrderInfo, apiGameInfo} from "@/request/API";

export default {
  name: "payment",
  props: {},
  components: {breadcrumb,countDown},
  data() {
    return {
      breadcrumbList: [
        {link: 'AllGame', name: '全部游戏'},
        {
          link: 'SelectGame', name: '', query: {
            game_alias: 'games',
            game_id: this.$route.query.game_id
          }
        },
        {
          link: 'GameDetails', name: '账号详情', query: {
            id: this.$route.query.id,
            game_id: this.$route.query.game_id,
            source_page: this.$route.path.slice(1)
          }
        },
        {name: '扫码支付'}
      ],
      orderid: this.$route.query.orderid,
      payResult: 'success',
      qrcode:'',
      orderInfo: {
        order_amount:'',
        expire_time:0,
        add_time:0,
      },
      // timer:null,
      alipayFrom:''
    }
  },
  methods: {
    payQuery() {
      apiPayQuery({
        id: this.orderid
      }).then(res => {
        if (res.data.code === 200) {
          this.payResult = 'success'
          // clearInterval(this.timer);
        }
      })
    },
    paydetail(){
      apiPaydetail({
        id: this.orderid,
        return_url:`${process.env.VUE_APP_WEBSITE}/payment?orderid=${this.orderid}&id=${this.$route.query.id}&game_id=${this.$route.query.game_id}`
      }).then(res=>{
        // this.qrcode = res.data.qr_code
        this.alipayFrom = res.data.from_data
        const div = document.createElement("divform");
        div.innerHTML = res.data.from_data
        document.body.appendChild(div);
        document.forms[0].acceptCharset = "GBK"; // 保持与支付宝默认编码格式一致，如果不一致将会出现：调试错误，请回到请求来源地，重新发起请求，错误代码 invalid-signature 错误原因: 验签出错，建议检查签名字符串或签名私钥与应用公钥是否匹配
        document.forms[0].submit();
        div.remove();
        // this.createQrcode()
      })
    },
    createQrcode() {
      var qrcode = new QRCode(this.$refs.qrCodeUrl,{
        text:this.qrcode,//可以是链接，也可以是文本
        width:216,//二维码的宽度
        height:216,//二维码的高度
        colorLight:'#ffffff',//二维码背景色
        colorDark:'#000000',//二维码前景色，以实现红码为例
        correctLevel: QRCode.CorrectLevel.H//纠错等级
      })
    },

    getOrderInfo(){
      apiOrderInfo({
        id:this.orderid
      }).then(res=>{
        this.orderInfo = res.data
      })
    },

    countDownChange(countDown) {
      if (countDown) {
        this.payResult = 'error'
        // clearInterval(this.timer);
      }
    },
    initSocket() {
      this.$WS.on('pc_alipay_detail_success', (e) => {
        if (e.data.out_trade_no == this.orderid) {
          this.payResult = 'success'
          // clearInterval(this.timer);
        }
      })
    },
  },
  watch: {
  },
  created() {
    // this.getOrderInfo()
    // this.paydetail()
    // this.payQuery()
    // this.initSocket()
  },
  mounted() {
/*    this.timer = setInterval(()=> {
      this.payQuery()
    }, 4000);*/
    apiGameInfo({
      id: this.$route.query.game_id
    }).then(res=>{
      this.breadcrumbList[1].name = res.data.game_name
    })
  }
}
</script>

<style scoped lang="less">
.payment {
  width: 1200px;

  .main {
    height: 759px;
    background: #FFFFFF url("../../../assets/image/AllGame/payment/bg.png") no-repeat;
    background-size: 100% 211px;
    display: flex;
    align-items: center;
    justify-content: center;

    .card {
      padding: 83px 115px 96px 127px;
      background: #FFFFFF;
      box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.05);
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;

      .card-left {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 0 29px 0 0;

        .title {
          font-size: 20px;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 800;
          color: #FFFFFF;
          line-height: 23px;
          display: flex;
          align-items: flex-end;

          img {
            width: 24px;
            height: 24px;
            margin: 0 9px 0 0;
          }

        }

        .price {
          font-size: 38px;
          font-family: PingFang SC-Semibold, PingFang SC;
          font-weight: 900;
          letter-spacing: -1px;
          color: var(--primary, #FF5A1F);
          line-height: 44px;
          margin: 0 0 14px;
        }

        #qrcode {
          width: 238px;
          height: 238px;
          background: url("../../../assets/image/AllGame/payment/qrcode_bg.png") no-repeat;
          margin: 0 0 22px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .tip {
          display: flex;
          align-items: baseline;
          font-size: 17px;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #000000;

          span {
            font-family: PingFang SC-Semibold, PingFang SC;
            font-weight: 800;
            color: var(--primary, #FF5A1F);
            margin: 0 9px;
          }

          img {
            width: 16.35px;
            height: 16.35px;
            margin: 0 0 0 8px;
          }

          i {
            margin: 0 0 0 7px;
          }
        }
      }

      .card-right {
        .time {
          font-size: 22px;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #000000;
          margin: 0 0 0 148px;

          span {
            color: var(--primary, #FF5A1F);
            font-weight: 800;
            margin: 0 0 0 17px;
          }
        }

        .scanCode {
          margin: 37px 0 51px;
          display: flex;
          align-items: center;

          img {
            width: 226px;
            height: 146px;
            margin: 0 35px 0 0;
          }

          .scanCode-tip {
            div {
              font-size: 14px;
              font-family: PingFang SC-Regular, PingFang SC;
              font-weight: 400;
              color: #1A1D24;

              span {
                display: block;
                margin: 0 0 4px;
                font-family: PingFang SC-Medium, PingFang SC;
                font-weight: 500;
              }
            }

            div:nth-of-type(2) {
              margin: 13px 0 15px;
              width: 192px;
              height: 1px;
              background-color: var(--border-soft, #E8E4DE);
            }
          }
        }

        .illustrate {
          padding: 16px 48px;
          background: var(--bg-tag, #F0EDE8);
          margin: 0 0 0 50px;

          div {
            font-size: 13px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #000000;
            text-align: center;
          }

          div:first-of-type {
            margin: 0 0 8px;

            span {
              margin: 0 0 0 2px;
              font-family: PingFang SC-Semibold, PingFang SC;
              font-weight: 800;
              color: var(--primary, #FF5A1F);
            }
          }
        }
      }
    }
  }

  .payment-success,.payment-error {
    .card {
      padding: 85px 337px 107px;
      display: flex;
      flex-direction: column;
      align-items: center;

      .title {
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 22px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #000000;

        img {
          margin: 0 0 5px;
          width: 120px;
          height: 119px;
        }
      }

      .illustrate {
        text-align: center;
        font-size: 14px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: var(--text-secondary, #5A5F6B);
        margin: 40px 0 35px;

        div {
          margin: 10px 0 0;
          font-size: 14px;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: var(--warning, #C9974D);
          line-height: 22px;
          padding: 8px 33px;
          text-align: center;
          background: var(--warning-soft, #F6EEDF);
          border-radius: 3px;
        }
      }

      .btn {
        width: 194px;
        height: 42px;
        line-height: 42px;
        text-align: center;
        font-size: 18px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 800;
        color: #FFFFFF;
        background: var(--primary, #FF5A1F);
        border-radius: 3px;
        cursor: pointer;
        user-select: none;
        transition: background-color 0.2s ease;
      }
      .btn:hover {
        background: var(--primary-hover, #E84A12);
      }
    }
  }
  .payment-error{
    .card{
      .illustrate{
        display: flex;
        align-items: center;
        i{
          margin: 0 5px 0 0;
          color: var(--warning, #C9974D);
        }
      }
    }
  }

}

</style>
